import React from 'react';
import Lz from 'pages/app-profiles/landing-zones/components/Form';
import { Grid } from '@mui/material';

const ADFFields = () => (
    <>
        <Grid item xs={6}>
            {' '}
            <Lz.Environments />
        </Grid>
        <Grid item xs={6}>
            {' '}
            <Lz.Region />
        </Grid>
        <Grid item xs={6}>
            <Lz.Subscription />
        </Grid>
        <Grid item xs={6}>
            {' '}
            <Lz.ResourceGroup />
        </Grid>
        <Grid item xs={6}>
            {' '}
            <Lz.DataClassification />
        </Grid>
        <Grid item xs={6}>
            {' '}
            <Lz.LandingZoneLabel />
        </Grid>
        <Grid item xs={6}>
            {' '}
            <Lz.LandingZoneDesc />
        </Grid>
    </>
);

export default ADFFields;
